module.exports = __webpack_public_path__ + "img/google.319fb3d0.webp";